import Work1 from '../../assets/work1.jpg'
import Work2 from '../../assets/work2.jpg'
import Work3 from '../../assets/work3.png'
import Work4 from '../../assets/work4.jpg'
import Work5 from '../../assets/work5.png'
import Work6 from '../../assets/work6.png'
export const projectsData = [
    {
        id: 1,
        image: Work1,
        title: "Operations Dashboard Using Tableau",
        category: "Data Visualisation",
        githubLink: "https://github.com/parimal1998/Operations-Dashboard-using-Tableau"
    },
    {
        id: 2,
        image: Work2,
        title: "Aggregation Pipeline Using MongoDB",
        category: "Databases",
        githubLink: "https://github.com/parimal1998/Aggregation-Pipeling-using-MongoDB"
    },
    {
        id: 3,
        image: Work3,
        title: "Predictive Maintenance of Renewable Plants Using Digital Twins",
        category: "Machine Learning",
        githubLink: "https://github.com/parimal1998/Predictive-Maintenance-of-Renewable-Plant-Using-Digital-Twins"
    },
    {
        id: 4,
        image: Work4,
        title: "Store Performance Analysis Using Power BI",
        category: "Data Visualisation",
        githubLink: "https://github.com/parimal1998/Bike-Store-Performance"
    },
    {
        id: 5,
        image: Work5,
        title: "House Prediction And Car Classification Using Machine Learning",
        category: "Machine Learning",
        githubLink: "https://github.com/parimal1998/Machine-Learning-House-Pricing-and-Car-Classification"
    },
    {
        id: 6,
        image: Work6,
        title: "SQL Analytical Functions",
        category: "Databases",
        githubLink: "https://github.com/parimal1998/SQL-Analytical-Functions"
    },
     
];

export const projectsNav = [
    {
        name: 'all',
    },
    {
        name: 'Data Visualisation',
    },
    {
        name: 'Databases',
    },
    {
        name: 'Machine Learning',
    },
];